import React from 'react';
import { Flex, Typography } from 'antd';
import styled from 'styled-components';

import { ExportsFormProps } from '../interface/exports.interface';
import { fields, renderField } from '../utils/fieldRender';

const { Text } = Typography;

export const ExportsForm: React.FC<ExportsFormProps> = ({ formik }) => {
    return (
        <form>
            <Flex vertical gap={24}>
                {fields.map(field => (
                    <Field key={field.id}>
                        <Text>{field.title}</Text>
                        {renderField(field.type, formik)}
                    </Field>
                ))}
            </Flex>
        </form>
    );
};

const Field = styled(Flex)`
    flex-direction: column;
    gap: 8px;
`;
